import { action } from 'easy-peasy';
import { IActionSetClients } from '../types';

const setClients: IActionSetClients = action((state, payload) => {
  const { items, pagination, filters } = payload;

  if (pagination) {
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
    state.pagination.total = pagination.total;
  }

  if (filters) {
    state.filters = filters;
  }

  state.list = items;
});

export default setClients;
